<template>
	<div>
		
		
		<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
			<div style="display: flex; flex-direction: row;">
				<div>
					<el-form-item label="模板名称" prop="template_name">
						<el-input size="small" v-model="ruleForm.template_name"></el-input>
					</el-form-item>
					
					<el-form-item label="模板描述" prop="template_desc">
						<el-input size="small" v-model="ruleForm.template_desc"></el-input>
					</el-form-item>
					
					<el-form-item label="商户号:" prop="merchant_no">
						<el-input size="small" v-model="ruleForm.merchant_no"></el-input>
					</el-form-item>
					
					<el-form-item label="商户密钥:" prop="merchant_key">
						<el-input size="small" v-model="ruleForm.merchant_key"></el-input>
					</el-form-item>
					
					<el-form-item label="备注:" prop="remark">
						<el-input type="textarea" rows="3" size="small" v-model="ruleForm.remark"></el-input>
					</el-form-item>
				</div>
				<div>
					<el-form-item label="示例图片:" prop="img_url">
						<el-upload class="avatar-uploader" :action="this.$http_host + '/Admin/Upload/uploadImage'" :headers="headers" :show-file-list="false"
							:on-success="UploadSuccess"
							:before-upload="beforeUpload"
							:on-error="UploadError"
						>
						  <img v-if="ruleForm.img_url" :src="ruleForm.img_url" class="avatar">
						  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
						</el-upload>
					</el-form-item>
				</div>
			</div>
			<el-form-item>
				<div style="display: flex; flex-direction: row; width: 100%; justify-content: center;">
					<el-button style="width: 270px;" type="danger" @click="submitForm('ruleForm')">确认保存</el-button>
				</div>
			</el-form-item>
		</el-form>
	</div>
</template>

<script>
	export default {
		props:['ruleForm'],
	    data() {
			return {
				rules: {
					template_name: [{required: true, message: '请输入模板名称', trigger: 'blur'}],
					template_desc: [{required: true, message: '请输入模板描述', trigger: 'blur'}],
					img_url: [{required: true, message: '请上传图片', trigger: 'blur'}],
					merchant_no: [{required: true, message: '请输入商户号', trigger: 'blur'}],
					merchant_key: [{required: true, message: '请输入商户密钥', trigger: 'blur'}],
					remark: [{required: true, message: '请输入备注信息', trigger: 'blur'}]
				},
				headers:{
					Authorization:'',
				}
	      };
	    },
		created() {
			this.headers.Authorization = localStorage.getItem('access_token');
		},
	    methods: {
			beforeUpload(file){
			},
			UploadSuccess(res, file, fileList){
				if(res.code == 200)
				{
					this.ruleForm.img_url = res.data.url;
				}else{
					return this.$message({ message: res.msg, type: 'warning' });
				}
			},
			UploadError(){
				return this.$message({ message: '上传失败，请重试', type: 'warning' });
			},
			
			submitApi(){
				let _this = this;
				const loading = this.$loading({
						lock: true,
						text: '编辑中',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.7)'
					});
				_this.$api.post("/Set/editAiTemplate", this.ruleForm).then(res=>{
					loading.close();
					if(res.code == 200)
					{
						_this.$message({
							 message: '编辑成功~',
							 type: 'success',
						});
					}else{
						return _this.$message({
							 message: res.msg,
							 type: 'warning',
						});
					}
				}).catch(err=>{
					loading.close();
				});
			},
			submitForm(formName) {
				let _this = this;
				this.$refs[formName].validate((valid) => {
					if (valid) {
						_this.submitApi();
					} else {
						return _this.$message({
							 message: '提交失败',
							 type: 'warning',
						});
					}
				});
			},
			resetForm(formName) {
				this.$refs[formName].resetFields();
			}
	    }
	  }
</script>

<style scoped>
	.avatar-uploader .el-upload {
	    border: 1px dashed #d9d9d9;
	    border-radius: 6px;
	    cursor: pointer;
	    position: relative;
	    overflow: hidden;
	  }
	  .avatar-uploader .el-upload:hover {
	    border-color: #409EFF;
	  }
	  .avatar-uploader-icon {
	    font-size: 28px;
	    color: #8c939d;
	    min-width: 220px;
	    height: 300px;
	    line-height: 300px;
	    text-align: center;
		border:dashed 1px #dcdcdc;
	  }
	  .avatar {
	    min-width: 220px;
	    height: 300px;
	    display: block;
	  }
</style>